import React from "react";
import PropTypes from "prop-types";
import { lightSealBlue, lightestGray, darkSkyBlue, red, greenSuccess } from "@govlaunch/palette";

/**
 * @param  {Boolean} disabled
 * @return {Object}
 */
function applyDisabledStyles({ disabled }) {
  if (disabled) {
    return {
      backgroundColor: lightestGray,
      border: "1px solid transparent",
    };
  }

  return null;
}

/**
 * @param  {Boolean} isOpen
 * @return {Object}
 */
function applyAttentionStyles({ isOpen }) {
  if (isOpen) {
    return {
      border: `solid 1px ${darkSkyBlue}`,
      borderBottom: "none",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    };
  }

  return null;
}

/**
 * @param  {String} validationState
 * @return {Object}
 */
function applyValidationStateStyles({ validationState }) {
  if (validationState === "error") {
    return {
      borderColor: red,
    };
  }

  if (validationState === "success") {
    return {
      borderColor: greenSuccess,
    };
  }

  return null;
}

export default function TagsInputContainer({ children, ...props }) {
  return (
    <div
      css={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        width: "100%",
        minHeight: 48,
        height: "100%",
        boxSizing: "border-box",
        borderRadius: 4,
        border: `solid 1px ${lightSealBlue}`,
        backgroundColor: "#ffffff",
        paddingRight: 20,
        ...applyDisabledStyles(props),
        ...applyAttentionStyles(props),
        ...applyValidationStateStyles(props),
      }}
    >
      {children}
    </div>
  );
}

TagsInputContainer.propTypes = {
  children: PropTypes.node.isRequired,
};
